import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../state'

import * as dataTab from './data-tab'
import * as generalTab from './general-tab'
import * as variablesTab from './variables-tab'

@ngCore.Component({
  imports: [
    dataTab.Component,
    generalTab.Component,
    variablesTab.Component,
    ds.button.Component,
    ds.input.text.Component,
    ds.layout.widget.Component,
    ds.overlay.centered.Component,
    ds.tabs.tab.Directive,
    ds.tabs.integratedVertical.Component,
  ],
  selector: 'atn-scenario-edit-dialog',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.routeBound.scenarios.Feature} */
  public readonly scenariosFeature = ngCore.inject(
    state.routeBound.scenarios.Feature,
  )

  /** @see {@link state.me.Feature} */
  private readonly _meFeature = ngCore.inject(state.me.Feature)

  /** Selected app */
  private readonly _selectedApp = this._meFeature.contexts.selectors.app

  public readonly selectedAppHasVariablesSg = ngCore.computed(
    (selectedApp = this._selectedApp.asSignal()) =>
      selectedApp?.scenarioVariables.length,
  )

  /** Submit changes handler */
  public saveClickHandler = () => {
    this.scenariosFeature.actions.submitEdit
      .from('EditScenarioDialog.SaveButton.Clicked')
      .dispatch()
  }

  /** Discard changes handler */
  public cancelClickHandler = () => {
    this.scenariosFeature.actions.cancelEdit
      .from('EditScenarioDialog.CancelButton.Clicked')
      .dispatch()
  }
}
